import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const Root = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: ${GrayColors["G-0"]};
  transition: background-color 200ms ease-in;
  cursor: pointer;

  &:hover {
    background-color: ${GrayColors["G-1"]};
    transition: background-color 200ms ease-out;
    svg {
      path {
        fill: ${GrayColors["G-4"]};
      }
    }
  }
`;
